import { Modal, Space } from 'antd'
import React from 'react'

import { formatCurrency } from '../../../formatters'

interface UploadTradeErrorsProps {
  failedTrades: any[]
  isVisible: boolean
  onClose: () => void
}

export const UploadTradesErrors = ({ failedTrades, isVisible, onClose }: UploadTradeErrorsProps) => (
  <Modal title="Upload Errors" centered open={isVisible} onCancel={onClose} footer={null}>
    <Space direction="vertical" className="upload-error-container">
      {failedTrades.map((item) => (
        <>
          <div>
            #{item.trade.key + 1}: {item.trade.instrumentCode} - coupon:{item.trade.coupon} - principal:
            {formatCurrency({ value: item.trade.principal })}
          </div>
          {Object.keys(item.error).map((key) => (
            <span>
              {key}: {item.error[key].map((row) => row.msg).join(', ')}
            </span>
          ))}
        </>
      ))}
    </Space>
  </Modal>
)
